<template>
    <ValidationObserver ref="observer">
        <b-card>
            <b-col>
                <hr />
                <b-row>
                    <b-col md="6" style="border-right: 1px solid lightgrey">
                        <b-row class="mb-3">
                            <b-col>
                                <ValidationProvider
                                    rules="required|numeric"
                                    v-slot="{ errors }"
                                    name="Id Proof No"
                                >
                                    <c-input
                                        inputType="text"
                                        inputId="idproofNo"
                                        lableText="ID Proof No. *"
                                        v-model="kyc.idproofNo"
                                        @input="$emit('readKYC', kyc)"
                                        :disabled="false"

                                    />
                                    <span class="validate-error custm-err">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row class="mb-3">
                            <b-col md="6" >
                                <p  class="ml-5">Photo ID Front</p>
                                <single-image
                                    class="ml-5"
                                    height="150px"
                                    width="115px"
                                    ref="photoIdFront"
                                    @change="
                                        (d) =>
                                            uploadImage(
                                                'photoIdFront',
                                                d,
                                                'frontSideFilePath',
                                                kyc.idproofNo,
                                            )
                                    "
                                    :id="'photo_id_front'"
                                    :url="kyc.photoIdFront"
                                    label="Photo ID Front"
                                ></single-image>
                            </b-col>
                            <b-col md="6">
                                <p  class="ml-2">Photo ID Back</p>
                                <single-image
                                    class="ml-2"
                                    height="150px"
                                    width="115px"
                                    ref="photoIdBack"
                                    @change="
                                        (d) =>
                                            uploadImage(
                                                'photoIdBack',
                                                d,
                                                'backSideFilePath',
                                                kyc.idproofNo,
                                            )
                                    "
                                    :id="'photo_id_back'"
                                    :url="kyc.photoIdBack"
                                    label="Photo ID Back"
                                ></single-image>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row class="mb-3">
                            <b-col>
                                <ValidationProvider
                                    :rules="{
                                        regex: /^[a-zA-Z0-9]+$/,
                                        required: true,
                                    }"
                                    v-slot="{ errors }"
                                    name="Address Proof No"
                                >
                                    <c-input
                                        inputType="text"
                                        inputId="addressproofNo"
                                        ref="addressproofNo"
                                        lableText="Address Proof No. *"
                                        v-model="kyc.addressproofNo"
                                        @input="$emit('readKYC', kyc)"
                                        :disabled="false"

                                    />
                                    <span class="validate-error custm-err">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row class="mb-3">
                            <b-col md="6">
                                <p class="ml-5">Address Proof Front</p>
                                <single-image
                                class="ml-5"
                                    height="150px"
                                    width="115px"
                                    ref="addressProofFront"
                                    @change="
                                        (d) =>
                                            uploadImage(
                                                'addressProofFront',
                                                d,
                                                'frontSideFilePath',
                                                kyc.addressproofNo,
                                            )
                                    "
                                    :id="'address_proof_front'"
                                    :url="kyc.addressProofFront"
                                    label="Address Photo"
                                ></single-image>
                            </b-col>
                            <b-col md="6">
                                <p class="ml-3">Address Proof Back</p>
                                <single-image
                                    class="ml-3"
                                    height="150px"
                                    width="115px"
                                    ref="addressProofBack"
                                    @change="
                                        (d) =>
                                            uploadImage(
                                                'addressProofBack',
                                                d,
                                                'backSideFilePath',
                                                kyc.addressproofNo,
                                            )
                                    "
                                    :id="'address_proof_back'"
                                    :url="kyc.addressProofBack"
                                    label="Address Proof Back"
                                ></single-image>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr />
            </b-col>

            <div
                v-if="!allImagesProvided && !filesSubmited"
                class="validate-error custm-err"
            >
                Upload all documents
            </div>

            <span v-if="unsuppprtedFile" class="validate-error custm-err"
                >Unsupported file format! Please select an image</span
            >
        </b-card>
        <slot name="footer-button" :data="kyc"></slot>
    </ValidationObserver>
</template>

<script>
import {
    ValidationProvider,
    ValidationObserver,
    Validator,
} from "vee-validate";
import Vue from "vue";
import SingleImage from "../../components/Common/Image.vue";
import cInput from "@/components/FormElements/CustomInput.vue";
export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        SingleImage,
        cInput,
    },
    props: ["kycData"],
    mounted() {
        this.KycDocuments = [...this.$route.params.kycData];
        if (this.kycData && typeof this.kycData === "object") {
            this.kyc = this.kycData;
        }
        Validator.extend("requiredFile", (value, [otherValue]) => {
            return this.filesSubmited == true;
        });
        this.$emit("readKYC", this.kyc);
    },
    data() {
        return {
            kyc: {
                addressProofFront: "",
                addressProofBack: "",
                photoIdFront: "",
                photoIdBack: "",
                idproofNo: "",
                addressproofNo: "",
            },
            unsuppprtedFile: false,
            filesSubmited: true,
            status: {
                idProofuploaded: false,
                addressProofuploaded: false,
            },
            KycDocuments: [],
        };
    },
    computed: {
        allImagesProvided() {
            const imageKeys = [
                "addressProofFront",
                "addressProofBack",
                "photoIdFront",
                "photoIdBack",
            ];
            return imageKeys.every((key) => this.kyc[key]);
        },
    },
    methods: {
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        isValid() {
            const isValid = this.$refs.observer.validate();
            this.$emit("isValid", isValid);
            return isValid;
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
        async uploadImage(path, image, photoKey, docNo) {
            if (!image.includes("data:image")) {
                this.kyc[path] = null;
                this.unsuppprtedFile = true;

                return;
            }
            this.unsuppprtedFile = false;

            let dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: ["kyc", "agent"],
            };
            this.showCustomToast();
            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    this.clearCustomToast();
                    this.kyc[path] = res.data.fileUrl;
                    this.$emit("readKYC", this.kyc);
                    if (this.$route.query.mode === "update") {
                        this.updatePhotoAndKyc(
                            path,
                            res.data.fileUrl,
                            photoKey,
                            docNo,
                        );
                    }
                })
                .catch((error) => {
                    this.clearCustomToast();
                    this.$toasted.error(
                        "Image not uploaded..please try again!",
                    );
                });
        },
        async updatePhotoAndKyc(path, fileUrl, photoKey, docNo) {
           let docObj = this.KycDocuments.find((el) =>
    path.includes("photo") ? el.category === "ID_PROOF" : el.category === "ADDRESS_PROOF"
);

            let payload = {
                documentNo: docNo,
            };
            if (path.includes("photo")) {
                payload.frontSideFilePath = this.kyc.photoIdFront;
                payload.backSideFilePath = this.kyc.photoIdBack;
            }
            if (path.includes("address")) {
                payload.frontSideFilePath = this.kyc.addressProofFront;
                payload.backSideFilePath = this.kyc.addressProofBack;
            }
            payload[photoKey] = fileUrl;
            try {
                await this.$store.dispatch("tenant/updateKYCByTenant", {
                    data: payload,
                    userId: this.$route.params.userData._id,
                    docId: docObj._id,
                });
                this.$toasted.success("kyc update successfull!!!");
            } catch (error) {
                this.$toasted.error("kyc update failed!!!");
                throw error;
            }
        },
        async submitKyc(userId) {
            let success = false;
            const payload = {
                userId: userId,
                documents: [
                    {
                        category: "ID_PROOF",
                        docType: "ID_PROOF",
                        documentNo: this.kyc.idproofNo,
                        frontSideFilePath: this.kyc.photoIdFront,
                        backSideFilePath: this.kyc.photoIdBack,
                    },
                    {
                        category: "ADDRESS_PROOF",
                        docType: "ADDRESS_PROOF",
                        documentNo: this.kyc.addressproofNo,
                        frontSideFilePath: this.kyc.addressProofFront,
                        backSideFilePath: this.kyc.addressProofBack,
                    },
                ],
            };
            try {
                await this.$store.dispatch("tenant/submitKYCByTenant", payload);
                this.showAlert("Success", "Success", "KYC Submitted For Agent");
                success = true;
            } catch (e) {
                this.showAlert("Error", "Error", "Error Submitting Kyc");
            }
            return success;
        },
        showAlert(type, title, text) {
            this.$swal({
                title,
                text,
                type,
            });
        },
    },
};
</script>
<style scoped>
[btn-color="primary"] {
    height: 41px;
    background-color: var(--primary);
    font-weight: 600;
    font-size: medium;
    letter-spacing: 2px;
    font-family: "Lato";
    color: white;
    border: 0px;
    border-radius: 0px;
}

[btn-special="primary"] {
    border: 0px;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: medium;
    font-family: "Lato";
    border-radius: 0px;
    height: 43px;
    width: 139px;
    background-color: var(--primary);
    color: white;
}
.card {
    border-width: 1160px;
    border-radius: 16px;
}
</style>
